import React from 'react';
import { useColorSet } from '../ThemeProvider/useColorSet';
export const CircularLoader = ({ size = 24, colorSet = 'default', }) => {
    const { content } = useColorSet({ colorSet });
    return (React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3", stroke: content, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
            React.createElement("animateTransform", { attributeName: "transform", attributeType: "XML", type: "rotate", from: "0 12 12", to: "360 12 12", dur: "1s", repeatCount: "indefinite" }))));
};
